import { useCallback, useEffect, useRef } from 'react';
import API_URL from '../../config/api';

/** Match backend SUPER_ADMIN_SESSION_MINUTES default (15). */
const IDLE_MS = 15 * 60 * 1000;

/**
 * Logs out platform operators after inactivity while on /admin routes.
 * Also pings the server to refresh admin_last_activity_at.
 */
export function useAdminIdleTimeout(onTimeout: () => void) {
  const onTimeoutRef = useRef(onTimeout);
  onTimeoutRef.current = onTimeout;

  const pingSession = useCallback(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${API_URL}/admin/security/session/ping`, {
      headers: { Authorization: `Bearer ${token}` },
    }).catch(() => {});
  }, []);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => onTimeoutRef.current(), IDLE_MS);
      pingSession();
    };

    const events: Array<keyof WindowEventMap> = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      clearTimeout(timer);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [pingSession]);
}
